<template>
  <span class="svg-icon-reward-empty-list">
    <svg width="126" height="117" viewBox="0 0 126 117" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="67.2578" cy="58.5" r="58" fill="url(#paint0_linear_5925_263628)"/>
    <g clip-path="url(#clip0_5925_263628)">
    <g opacity="0.85">
    <path d="M12.8086 30.0332C10.7896 30.8744 10.1166 31.5474 9.27539 33.5664C8.43415 31.5474 7.76116 30.8744 5.74219 30.0332C7.76116 29.192 8.43415 28.519 9.27539 26.5C10.1166 28.519 10.7896 29.192 12.8086 30.0332Z" fill="#C6C9D2"/>
    </g>
    </g>
    <g clip-path="url(#clip1_5925_263628)">
    <g opacity="0.85">
    <path d="M20.7862 17.9918C18.2195 19.0612 17.364 19.9168 16.2945 22.4835C15.225 19.9168 14.3695 19.0612 11.8027 17.9918C14.3695 16.9223 15.225 16.0667 16.2945 13.5C17.364 16.0667 18.2195 16.9223 20.7862 17.9918Z" fill="#C6C9D2" fill-opacity="0.75"/>
    </g>
    </g>
    <g clip-path="url(#clip2_5925_263628)">
    <g opacity="0.85">
    <path d="M4.74023 18.4968C3.59738 18.973 3.21642 19.354 2.74023 20.4968C2.26404 19.354 1.88309 18.973 0.740234 18.4968C1.88309 18.0206 2.26404 17.6397 2.74023 16.4968C3.21642 17.6397 3.59738 18.0206 4.74023 18.4968Z" fill="#C6C9D2" fill-opacity="0.5"/>
    </g>
    </g>
    <g clip-path="url(#clip3_5925_263628)">
    <g opacity="0.85">
    <path d="M51.8547 73.5592C48.3945 75.0009 47.2412 76.1543 45.7994 79.6145C44.3577 76.1543 43.2043 75.0009 39.7441 73.5592C43.2043 72.1175 44.3577 70.9641 45.7994 67.5039C47.2412 70.9641 48.3945 72.1175 51.8547 73.5592Z" fill="#C6C9D2"/>
    </g>
    </g>
    <g clip-path="url(#clip4_5925_263628)">
    <g opacity="0.85">
    <path d="M88.3535 90.8108C86.464 91.5981 85.8342 92.2279 85.0469 94.1174C84.2596 92.2279 83.6297 91.5981 81.7402 90.8108C83.6297 90.0235 84.2596 89.3937 85.0469 87.5042C85.8342 89.3937 86.464 90.0235 88.3535 90.8108Z" fill="#C6C9D2"/>
    </g>
    </g>
    <path d="M124.53 11.109C125.142 9.56951 124.391 7.82499 122.851 7.21251C121.312 6.60002 119.567 7.35151 118.955 8.891L124.53 11.109ZM10.6833 110.967C29.9876 108.098 53.755 94.8158 74.8854 76.6499C96.0662 58.4408 115.049 34.9398 124.53 11.109L118.955 8.891C109.936 31.5602 91.6682 54.3092 70.974 72.1001C50.2294 89.9342 27.4968 102.402 9.80109 105.033L10.6833 110.967Z" fill="url(#paint1_linear_5925_263628)"/>
    <circle cx="41.7422" cy="61.5" r="2" fill="white"/>
    <circle cx="34.2422" cy="25" r="1.5" fill="white"/>
    <circle cx="21.7422" cy="62.5" r="3" fill="white"/>
    <defs>
    <linearGradient id="paint0_linear_5925_263628" x1="80.8563" y1="10.1015" x2="67.3013" y2="98.8611" gradientUnits="userSpaceOnUse">
    <stop stop-color="#C6C9D2"/>
    <stop offset="1" stop-color="#C6C9D2" stop-opacity="0"/>
    </linearGradient>
    <linearGradient id="paint1_linear_5925_263628" x1="113.242" y1="45.5" x2="33.7422" y2="114" gradientUnits="userSpaceOnUse">
    <stop stop-color="#C6C9D2"/>
    <stop offset="1" stop-color="#C6C9D2" stop-opacity="0"/>
    </linearGradient>
    <clipPath id="clip0_5925_263628">
    <rect width="7.06641" height="7.06641" fill="white" transform="translate(5.74219 26.5)"/>
    </clipPath>
    <clipPath id="clip1_5925_263628">
    <rect width="8.98351" height="8.98351" fill="white" transform="translate(11.8047 13.5)"/>
    </clipPath>
    <clipPath id="clip2_5925_263628">
    <rect width="4" height="4" fill="white" transform="translate(0.742188 16.5007)"/>
    </clipPath>
    <clipPath id="clip3_5925_263628">
    <rect width="12.1106" height="12.1106" fill="white" transform="translate(39.7422 67.5)"/>
    </clipPath>
    <clipPath id="clip4_5925_263628">
    <rect width="6.61328" height="6.61328" fill="white" transform="translate(81.7422 87.5)"/>
    </clipPath>
    </defs>
    </svg>
  </span>
</template>

<script>
export default {
  props: {
    width: { type: Number, default: 24 },
    color: { type: String, default: '#DB9A00' },
    color2: { type: String, default: '#E0E3E6' },
    isTwoTone: { type: Boolean },
    isSolid: { type: Boolean }
  }
}
</script>
